import MainDisciplineForm from "./MainDisciplineForm";

export default MainDisciplineForm;